import YDivider from './src/main'

YDivider.install = function(Vue) {
  Vue.component(YDivider.name, YDivider)
}

export default YDivider
